import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const purchaseProductApi = async (data) =>
    Promise.resolve(axios.post(endpoints.purchasedProducts, data));
